import { BaseAPI } from './baseAPI';
import { ContentPageOptions } from './options/contentPageOptions';
import { ContentPageRequest } from './request/contentPageRequest';
import { ContentPageResponse } from './response/contentPageResponse';
import AxiosInstance from './axiosInstanceService';
import { ContentPageStatsResponse } from './response/contentPageStatsResponse';

export class ContentPageAPI extends BaseAPI<
  ContentPageResponse,
  ContentPageOptions,
  ContentPageRequest
> {
  constructor() {
    super('ContentPage');
  }

  public CreateFormData = (req: FormData, timeout = 60000) =>
    AxiosInstance.post<ContentPageResponse>(`${this.controllerPath}`, req, {
      timeout,
    });

  public LogViewV2 = (
    contentPageId: number | string,
    source: 'web' | 'mobile',
  ) =>
    AxiosInstance.post<void>(`v2/ContentPage/${contentPageId}/view`, {
      source,
    }) as unknown as Promise<void>;

  public GetStatsV2 = (contentPageId: number | string, rangeDays: number) =>
    AxiosInstance.get<ContentPageStatsResponse>(
      `v2/ContentPage/${contentPageId}/stats`,
      {
        params: { rangeDays },
      },
    ) as unknown as Promise<ContentPageStatsResponse>;
}
